var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssinaturaDigitalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 82,
    viewBox: "0 0 67 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1693 52.4247C12.4267 49.0059 14.5591 41.9796 21.0301 41.2252C29.119 40.2822 31.1995 52.5017 18.1878 47.7876C5.17604 43.0735 37.6647 57.3232 40.8365 45.1472",
    stroke: "#00D88A",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0362 12H8.80724C7.00185 12 5.2704 12.7164 3.99379 13.9916C2.71719 15.2669 2 16.9964 2 18.7999V73.199C2 75.0024 2.71719 76.732 3.99379 78.0072C5.2704 79.2824 7.00185 79.9989 8.80724 79.9989H49.6507C51.4561 79.9989 53.1875 79.2824 54.4641 78.0072C55.7407 76.732 56.4579 75.0024 56.4579 73.199V32.3997",
    stroke: "#5A57FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8056 60.5396H15.4014",
    stroke: "#ADABFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12285_5611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.375 13.5L53.5 5.625L56.875 2.25L64.75 10.125L61.375 13.5Z",
    stroke: "#00D88A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.625 6.75L46.1875 8.4375L42.25 24.75L58.5625 20.8125L60.25 12.375L54.625 6.75Z",
    stroke: "#00D88A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.25 24.75L50.7843 16.2157",
    stroke: "#00D88A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6255 14.625C54.6255 13.3824 53.6181 12.375 52.3755 12.375C51.1328 12.375 50.1255 13.3824 50.1255 14.625C50.1255 15.8676 51.1328 16.875 52.3755 16.875C53.6181 16.875 54.6255 15.8676 54.6255 14.625Z",
    stroke: "#00D88A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12285_5611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(40 27) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssinaturaDigitalIcon);
export default __webpack_public_path__ + "static/media/assinatura-digital-icon.2b7737f82a758b31082949d8f7315a6a.svg";
export { ForwardRef as ReactComponent };